/**
 * @param controller Stimulus controller
 * @param callback {function(user: ?Object): void}
 * @returns {function(): void}
 */
export default (controller, callback) => {
    // keep a copy of the current disconnect() function of the controller
    // to support composing several behaviors
    const controllerDisconnect = controller.disconnect?.bind(controller) || (() => {});

    const disconnect = () => {
        document.removeEventListener('userSessionUpdated', callback);

        controllerDisconnect();
    };

    Object.assign(controller, {
        disconnect,
    });

    document.addEventListener('userSessionUpdated', () => {
        callback(JSON.parse(sessionStorage.getItem('user')));
    });

    if (sessionStorage.getItem('user-loaded') === 'true') {
        callback(JSON.parse(sessionStorage.getItem('user')));
    }
};
